<template>
  <div class="mitu_order_layout">
    <!-- 活动标题 -->
    <div v-wechat-title="'迷途之光'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' v-on:channelCallback='selectCallback' @loginSuccess="loginSuccess" :gameName="gameName"
      :downloadUrl="downloadUrl" :loginTypes="loginTypes" channelTips="角色UID可在游戏中—设置—UID查看" :autoOpenOS="false"
      noAuthLogin></Login>
    <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback='osCancell'
      @getSelectInfo='getSelectInfo' :gameName="gameName"></Os>
    <Header v-if='true' :config='headerConfig' :isShowInfo='true' :isOnline='1' @reInit="reInit"
      @onOfficial="onOfficial" />
    <div :class="'super_punch_clock_page ' + (isSafari ? 'safari' : '')" ref="bg">

      <div class="index" ref="myDiv">
        <div class="main_01" id="#0" ref="myDiv0">
          <div class="title_mini"></div>
          <div class="title"></div>
          <div class="title_text"></div>
          <div class="content">
            <div class="time">{{ countDownNum }}</div>
            <div class="num">当前预约人数：{{ hotNum }}</div>
            <div class="order_active" v-if="!isUserInfo" @click="doneTask()"></div>
            <div class="order_active" v-else @click="scrollToElement('tag1')"></div>
            <div class="load_box">
              <a class="btn tap" href="https://l.taptap.cn/WYEHJB1E?channel=rep-rep_hbfjlssqrjj"
                @click="btnClick('tap')"></a>
              <a class="btn helper" @click="doneTask(2)"></a>
              <a class="btn haoyou" href="https://www.3839.com/a/164372.htm" @click="btnClick('haoyou')"></a>
            </div>
          </div>
        </div>
        <div class="main_bg">
          <div class="main_02">
            <div class="title_02" id="#1" ref="myDiv1">
              <div class="title_02_text"></div>
            </div>
            <div class="box">
              <div v-for="item in card" :key="item.photo" class="box_item">
                <img :src="item.photoSrc">
              </div>
              <div class="move"></div>
            </div>
            <div class="people" id="tag1"></div>

          </div>
          <div class="main_03">
            <div class="title_03" id="#1" ref="myDiv1">
              <div class="title_03_text"></div>
            </div>
            <div class="team">
              <div class="add_box">
                <div class="add_item">
                  <template v-if="activity.invitation.length && activity.invitation[0]">
                    <div class="add_item_text">{{ activity.invitation[0] }}</div>
                    <img src="https://download4.qcplay.com/h5-images/active/mitu/order/03/tancai_stand1.png">
                    <div class="add_item_success"></div>
                  </template>
                  <div v-else style="width: 100%;height: 100%;" @click="openPopup('copyShow')"></div>
                </div>
                <div class="add_item">
                  <template v-if="activity.invitation.length && activity.invitation[1]">
                    <div class="add_item_text">{{ activity.invitation[1] }}</div>
                    <img src="https://download4.qcplay.com/h5-images/active/mitu/order/03/tancai_stand1.png">
                    <div class="add_item_success"></div>
                  </template>
                  <div v-else style="width: 100%;height: 100%;" @click="openPopup('copyShow')"></div>
                </div>
              </div>
              <div :class="activity.task_list[3].is_get_reward ? 'price_active' : 'price'"></div>
              <div class="link">
                <div class="link_text">
                  {{ shareLink }}
                </div>
                <a id="link_btn" href="javascript:;" class="link_btn" i @click="onCopy('#link_btn')"
                  :data-clipboard-text='"就差你了！超爽肉鸽像素弹幕射击游戏《迷途之光》6月20日上线，点击下方链接加入小队预约游戏领海量奖励！" + shareLink'></a>
              </div>
              <div class="task">
                <div class="task_item" v-for="item in task_item_list" :key="item.key"
                  :style="{ 'background-position': item.item_position }">
                  <div :class="task_list[item.key - 1].status ? 'task_btn active' : 'task_btn'"
                    :style="{ 'background-position': item.btn_position }" @click="doneTask(item.key)"></div>
                </div>
              </div>
            </div>

            <div class="get_box">
              <div v-if="rewardSum < 4" :class="activity.reward_start ? 'get_btn' : 'get_btn disabled'"
                @click="getReward"></div>
              <div v-else class="get_btn active"></div>
              <div class="get_text"></div>
            </div>
            <div class="flag"></div>

          </div>
          <div class="main_04">
            <div class="title_04" id="#1" ref="myDiv1"></div>
            <div class="avatar">
              <div :class="'avatar_item ' + (item.key === character.key ? 'active' : '')" v-for="item in avatar"
                :key="item.key"
                :style="{ 'background-position': item.position, 'top': item.top, 'left': item.left, 'filter': item.key === character.key ? 'brightness(100%)' : 'brightness(50%)' }"
                @click="clickAvatar(item)">
                <div class="avatar_item_border" v-if="item.key === character.key"></div>
              </div>
            </div>
            <div class="character">
              <div class="character_img">
                <img :src="character.photo" :alt="character.name">
              </div>
              <div class="character_box">
                <div class="character_title">{{ character.name }}</div>
                <div class="character_line"></div>
                <div class="character_text">{{ character.text }}</div>
              </div>
              <div class="gif_box" id="gif_box" ref="gif_box">
                <img :src="gif_link" loading="lazy">
                <!-- <img src="https://download4.qcplay.com/h5-images/active/mitu/order/04/1.gif" :src="gif_link" loading="lazy"> -->
              </div>
              <div class="flag"></div>
            </div>
          </div>
          <div class="main_05">
            <div class="title_05" id="#1" ref="myDiv1"></div>
            <div class="swiper_box">
              <!-- 设置左右切换按钮 -->
              <div class="swiper-button-next3 ani-btn arrow"></div>
              <div class="swiper-button-prev3 ani-btn arrow"></div>
              <div class="swiper-container " ref="mySwiper">
                <div class="swiper-wrapper">
                  <!-- 插入你的轮播内容 -->
                  <div class="swiper-slide" v-for="(item, index) in mdv" :key="index">
                    <img :src="item.photo" alt="" :style="os == 'iOS' ? 'left: 48.8%;' : 'left: 49%;'" loading="lazy" />
                  </div>
                </div>
                <div class="swiper-pagination"></div>
              </div>
            </div>
            <div class="title_06" id="#1" ref="myDiv1"></div>
            <div class="rule" id="#1" ref="myDiv1"></div>
            <div class="bottom" id="#1" ref="myDiv1"></div>
          </div>
        </div>
      </div>
      <div class="foot-page">
        <Footer :gameName="gameName" />
      </div>
    </div>

    <!-- 微信下载 -->
    <div class="wx_download_wrap popup_wrap" v-show="wxLoadShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="wx_download_wrap_content" @click="closePopup('wxLoadShow')"></div>
      </transition>
      <div class="close-bg" v-if="wxLoadShow" @click="closePopup('wxLoadShow')"></div>
    </div>

    <!-- 信息列表 -->
    <div class="rule_wrap popup_wrap" v-show="showImgShow" @click="closePopup('showImgShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <img class="swiper-lazy" :src="showImg" alt="详情">
          </div>
        </div>
      </transition>
    </div>

    <!-- 公众号列表 -->
    <div class="code_wrap popup_wrap" v-show="codeImgShow" @click="closePopup('codeImgShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <img class="swiper-lazy" :src="codeImg" alt="详情">
          </div>
        </div>
      </transition>
    </div>

    <!-- 领取确认 -->
    <div class="sure_wrap popup_wrap" v-show="sureShow" @click="closePopup('sureShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <img class="swiper-lazy" :src="sureImg" alt="详情">
            <div class="sure_text">
              <div>该奖励仅可领取一次</div>
              <div>当前将领取到{{ userInfo.server_name }}服{{ userInfo.role_name }}角色</div>
            </div>
            <div class="btn_box">
              <div class="sure_btn" @click="reward()"></div>
              <div class="switch_btn" @click="changeOsPopup(true)"></div>

            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- 信息列表 -->
    <div class="copy_wrap popup_wrap" v-show="copyShow" @click="closePopup('copyShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <img class="swiper-lazy" :src="copyImg" alt="详情">
            <div class="link">
              <div class="link_text">
                {{ shareLink }}
              </div>
              <a id="link_btn" href="javascript:;" class="link_btn" i @click="onCopy('#link_btn')"
                :data-clipboard-text='"就差你了！超爽肉鸽像素弹幕射击游戏《迷途之光》6月20日上线，点击下方链接加入小队预约游戏领海量奖励！" + shareLink'></a>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '../Header/index.vue';
import Footer from "@/components/Footer";
import { headerConfig } from '../headerConfig';
import { onGetInitDataAPI, hotNum, reward, task, invite } from '../api';
import { getRandomString, buriedLogger, wechatBrowser } from '@/utils/utils';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Clipboard from 'clipboard';
// import Header from '@/components/Header';

// import eruda from 'eruda';

export default {
  name: 'order',
  components: {
    Header,
    Login,
    Os,
    swiper,
    swiperSlide,
    Footer
  },
  data() {
    return {
      headerConfig,
      gameName: 'mzzg',
      is_access_token: '',
      downloadUrl: 'https://sglxs.qingcitimes.com/',
      loginTypes: ["sms", "password"],
      preloadingShow: true,
      titleShow: true,
      preventShow: false,
      logger: null,
      isWechatBrowser: false, // 是否为微信浏览器
      isSafari: false,
      hotNum: 0,
      countDownNum: '',
      open_link: '',
      task_list: [
        {
          "id": 1,
          "name": "\u524d\u5f80TapTap\u9884\u7ea6\u5e76\u8bc4\u4ef7\u6e38\u620f",
          "status": false,
          "package_id": 1,
          "num": 1,
          "is_get_reward": false
        },
        {
          "id": 2,
          "name": "\u6dfb\u52a0\u4f01\u4e1a\u5fae\u4fe1",
          "status": false,
          "package_id": 2,
          "num": 1,
          "is_get_reward": false
        },
        {
          "id": 3,
          "name": "\u5173\u6ce8\u300a\u8ff7\u9014\u4e4b\u5149\u300b\u516c\u4f17\u53f7",
          "status": false,
          "package_id": 3,
          "num": 1,
          "is_get_reward": false
        },
        {
          "id": 4,
          "name": "\u9080\u8bf7\u597d\u53cb",
          "status": false,
          "package_id": 4,
          "num": 2,
          "is_get_reward": false
        }
      ],
      card: [
        {
          photoSrc: 'https://download4.qcplay.com/h5-images/active/mitu/order/02/1.png',
          photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/02/1.png',
          photo_active: 'https://download4.qcplay.com/h5-images/active/mitu/order/02/1_acitve.png'
        },
        {
          photoSrc: 'https://download4.qcplay.com/h5-images/active/mitu/order/02/2.png',
          photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/02/2.png',
          photo_active: 'https://download4.qcplay.com/h5-images/active/mitu/order/02/2_acitve.png'
        },
        {
          photoSrc: 'https://download4.qcplay.com/h5-images/active/mitu/order/02/3.png',
          photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/02/3.png',
          photo_active: 'https://download4.qcplay.com/h5-images/active/mitu/order/02/3_acitve.png'
        },
        {
          photoSrc: 'https://download4.qcplay.com/h5-images/active/mitu/order/02/4.png',
          photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/02/4.png',
          photo_active: 'https://download4.qcplay.com/h5-images/active/mitu/order/02/4_acitve.png'
        },
        {
          photoSrc: 'https://download4.qcplay.com/h5-images/active/mitu/order/02/5.png',
          photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/02/5.png',
          photo_active: 'https://download4.qcplay.com/h5-images/active/mitu/order/02/5_acitve.png'
        },
      ],
      character: {
        photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/04/1.png',
        name: '龙樱',
        text: '龙樱对召唤物有种莫名其妙的亲近感，她可以对所有召唤物的属性进行加成。',
        key: 1
      },
      avatar: [
        {
          position: '0% 0%',
          top: '',
          left: '',
          key: 1,
          character: {
            photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/04/1.png',
            name: '龙樱',
            text: '龙樱对召唤物有种莫名其妙的亲近感，她可以对所有召唤物的属性进行加成'
          }
        },
        {
          position: '14% 0%',
          top: '50%',
          left: '-5%',
          key: 2,
          character: {
            photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/04/2.png',
            name: '火洛',
            text: '拥有暴击的火洛疯起来自己都怕！陨石伤害与攻击力相关。'
          }
        },
        {
          position: '28% 0%',
          left: '-10%',
          key: 4,
          character: {
            photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/04/3.png',
            name: '云筱',
            text: '云筱队长正在待命!节约是一种美德，一发子弹能打多个敌人就是对美德的诠释!'
          }
        },
        {
          position: '43% 0%',
          left: '-15%',
          top: '50%',
          key: 3,
          character: {
            photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/04/4.png',
            name: '零',
            text: '只有机器才不会背叛!零拥有多弹道攻击花里胡哨的。'
          }
        },
        {
          position: '57% 0%',
          left: '-20%',
          key: 5,
          character: {
            photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/04/5.png',
            name: '红鹦',
            text: '每释放一个技能丢一个炸弹，炸弹伤害与攻击力相关。'
          }
        },
        {
          position: '71% 0%',
          top: '50%',
          left: '-26%',
          key: 6,
          character: {
            photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/04/6.png',
            name: '灵儿',
            text: '灵儿是靠能量消耗来打伤害，消耗能量释放能量炮，能量炮伤害与最大能量相关。'
          }
        },
        {
          position: '85.5% 0%',
          left: '-31%',
          key: 7,
          character: {
            photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/04/7.png',
            name: '汤圆',
            text: '呵呵呵，人家的料理才不黑暗呢，汤圆普攻击中敌人概率喷射汤汁。'
          }
        },
        {
          position: '100% 0%',
          top: '50%',
          left: '-36%',
          key: 8,
          character: {
            photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/04/8.png',
            name: '铃铛',
            text: '钱越多心里越踏实！铃铛会根据自己局内拥有的金币数量而提高相应的属性。'
          }
        },
      ],
      mdv: [
        {
          photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/05/1.png'
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/05/2.png'
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/05/3.png'
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/05/4.png'
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/05/5.png'
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/05/6.png'
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/mitu/order/05/7.png'
        },
      ],
      task_item_list: [
        {
          item_position: '0% 0%',
          btn_position: '66.5% 0%',
          key: 1
        },
        {
          item_position: '0% 51%',
          btn_position: '33.5% 0%',
          key: 3
        },
        {
          item_position: '0% 100%',
          btn_position: '100% 0%',
          key: 2
        }
      ],
      messageImg: '',
      isPC: false,
      selectInfo: {},
      isExpanded: true,
      codeShow: false,
      messageShow: false,
      wxLoadShow: false,
      isUserInfo: false,
      shareLink: '',
      user_info: {},
      observer: null,
      loopInt: null,
      rewardSum: 0,
      os: '',
      activity: {
        "invitation": [
        ],
        "task_list": [
          {
            "id": 1,
            "name": "\u524d\u5f80TapTap\u9884\u7ea6\u5e76\u8bc4\u4ef7\u6e38\u620f",
            "status": false,
            "package_id": 1,
            "num": 1,
            "is_get_reward": false
          },
          {
            "id": 2,
            "name": "\u6dfb\u52a0\u4f01\u4e1a\u5fae\u4fe1",
            "status": false,
            "package_id": 2,
            "num": 1,
            "is_get_reward": false
          },
          {
            "id": 3,
            "name": "\u5173\u6ce8\u300a\u8ff7\u9014\u4e4b\u5149\u300b\u516c\u4f17\u53f7",
            "status": false,
            "package_id": 3,
            "num": 1,
            "is_get_reward": false
          },
          {
            "id": 4,
            "name": "\u9080\u8bf7\u597d\u53cb",
            "status": false,
            "package_id": 4,
            "num": 2,
            "is_get_reward": false
          }
        ],
        "code": "feHrfhzH",
        "reward_start": false,
        "url_scheme": "weixin:\/\/dl\/business\/?t=o4RzaIEHSMa"
      },
      isRewardStart: false,
      showImg: '',
      showImgShow: false,
      codeImg: 'https://download4.qcplay.com/h5-images/active/mitu/order/pop/code.png',
      codeImgShow: false,
      sureImg: 'https://download4.qcplay.com/h5-images/active/mitu/order/pop/sureText.png',
      sureShow: false,
      copyShow: false,
      copyImg: 'https://download4.qcplay.com/h5-images/active/mitu/order/pop/copy.png',
      inviteSgin: true,
      gif_link: ''
    };
  },
  created() {
    function detectOS() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone 必须先检查，因为它的 userAgent 也包含 "Android"  
      if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
      }

      if (/android/i.test(userAgent)) {
        return "Android";
      }

      // iOS检测  
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      }

      return "unknown";
    }

    this.os = detectOS();
    this.countDown(this)
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    this.isWechatBrowser = wechatBrowser();
    if (this.isWechatBrowser) { // 在微信app下

    } else {
      // safari下底部被遮住
      if ((/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))) {
        this.isSafari = true;
      }
    }

    // 埋点
    const bl = buriedLogger('mzzg', '迷途之光');
    this.logger = bl;
    this.messageImg = null
    const reload = () => {
      const { protocol, host } = window.location;
      const link = `${protocol}//${host}/mitu/order/enter${getRandomString()}`;
      setTimeout(() => {
        window.location.href = `${link}?referer=game`;
      }, 200);
    };
    this.getUserInfo()


    var userAgent = navigator.userAgent.toLowerCase();
    this.isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;
    if (this.isPC) {
      this.$router.push(`pc${getRandomString()}`);
    } else {
    }

  },
  mounted() {
    this.getHotNum()
    this.swiperInit()
    window.addEventListener('resize', this.swiperInit);
    this.observeElement()
    // let el = document.createElement('div');
    // document.body.appendChild(el);

    // eruda.init({
    //   container: el,
    //   useShadowDom: true
    // });

  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        // console.log('oldValue------>', oldValue)
        // console.log('newValue------>', newValue)
        if (oldValue.account) {
          if (newValue.account !== oldValue.account) {

            if (!newValue.account) {
              // TAG: 注销的时候
              // this.clearActiveInfo();
              this.reInit()
            } else {
              console.log('登录成功')
              this.getUserInfo()
            }
          }
        }

      }
    },
  },
  beforeDestroy() {
    this.observer.unobserve(this.$refs.gif_box);
  },
  methods: {

    btnClick(str) {
      this.logger.sum(`迷途之光_预约页_按钮点击，${str}`)
    },
    observeElement() {
      const options = {
        root: null, // relative to document viewport
        rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
        threshold: 0,  // 目标元素完全进入或离开视口中间位置时触发回调
      };

      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (!this.gif_link) {
              this.gif_link = 'https://download4.qcplay.com/mtzg/gif/1.gif'
            }
          } else {
          }
        });
      }, options);

      this.observer.observe(this.$refs.gif_box);
    },
    countDown(that) {
      function startCountdown(endDate) {

        function updateCountdown() {
          const now = new Date().getTime();
          const distance = endDate - now;

          if (distance < 0) {
            // 倒计时结束
            that.countDownNum = '现已上线！';
            that.isRewardStart = true;
            clearInterval(interval);
            return;
          }

          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);
          that.countDownNum = `上线倒计时：${days}天${hours}小时${minutes}分`
        }

        updateCountdown();
        const interval = setInterval(updateCountdown, 10000);
      }

      const targetDate = new Date();
      targetDate.setMonth(5); // 6月
      targetDate.setDate(20);
      targetDate.setHours(10);
      targetDate.setMinutes(0);
      targetDate.setSeconds(0);
      targetDate.setMilliseconds(0);

      startCountdown(targetDate.getTime());

      // if (timestamp <= currentTimeStamp) {
      //   this.isRewardStart = true
      //   that.countDownNum = timestampToDaysHoursMinutes(timestamp - currentTimeStamp)
      // } else {
      //   this.isRewardStart = false
      //   that.countDownNum = timestampToDaysHoursMinutes(currentTimeStamp - timestamp)
      // }

    },
    clickAvatar(item) {
      this.character = item.character
      this.character.key = item.key
      this.gif_link = `https://download4.qcplay.com/mtzg/gif/${item.key}.gif`
    },
    swiperInit() {
      var swiper = new Swiper('.swiper-container', {
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        nextButton: '.next',
        prevButton: '.prev',
        spaceBetween: '0%',
        slidesPerView: 'auto',
        autoplayDisableOnInteraction: false,
        // autoplay: 2000,
        prevButton: '.swiper-button-prev3',
        nextButton: '.swiper-button-next3',
        pagination: '.swiper-pagination',
      });
    },
    invite() {
      if (!this.$route.query.invitation_code) return
      const that = this
      const params = {
        invitation_code: this.$route.query.invitation_code
      }
      invite(params).then(res => {
        this.messageImg = null
        if (res.code === 200) {
          this.showImg = 'https://download4.qcplay.com/h5-images/active/mitu/order/pop/success.png',
            console.log('加入成功')
          that.showImgShow = true
        }
        if (res.code === 404) {
          this.showImg = 'https://download4.qcplay.com/h5-images/active/mitu/order/pop/repeat.png',
            console.log('很抱歉,已加入其它小队')
          that.showImgShow = true
        }
        if (res.code === 402) {
          this.showImg = 'https://download4.qcplay.com/h5-images/active/mitu/order/pop/full.png',
            console.log('队伍已满')
          that.showImgShow = true
        }
        if (res.code === 405) {
          this.showImg = 'https://download4.qcplay.com/h5-images/active/mitu/order/pop/now.png',
            console.log('已经在当前小队')
          that.showImgShow = true
        }
        if (res.code === 406) {
          this.showImg = 'https://download4.qcplay.com/h5-images/active/mitu/order/pop/fail.png',
            console.log('不能加入自己小队')
          that.showImgShow = true
        }

      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        that.getUserInfo()
      })
    },
    doneTask(index) {
      if (!this.userInfo.account) {
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }
      // if (this.task_list[index - 1].status) return this.onToast('该任务已完成');

      const open_link = localStorage.getItem('open_link')
      const that = this
      if (index == 2) {
        this.logger.sum('迷途之光_预约页_任务二，添加企业微信');
        this.logger.sum('迷途之光_预约页_点击前往小程序wiki');
        document.onvisibilitychange = function () {
          if (document.visibilityState == 'visible') {
            that.logger.sum('迷途之光_预约页_小程序返回活动页');
            console.log('切回应用');
            that.getUserInfo()
            that.loopInt = setInterval(function () {
              console.log('检测是否返回应用');
              that.getUserInfo()
            }, 1000)
            setTimeout(function () {
              console.log('清除定时器');
              clearInterval(that.loopInt)
            }, 15000)
          }

        }
        window.location.href = open_link
        return
      }
      const params = {
        task_id: index
      }
      if (index == 1) {
        window.location.href = "https://l.taptap.cn/WYEHJB1E?channel=rep-rep_hbfjlssqrjj"
        setTimeout(() => {
          if (this.task_list[index - 1].status) return this.onToast('该任务已完成');
          this.logger.sum('迷途之光_预约页_任务一，前往TAP');
          task(params).then((res) => {
            console.log('完成任务')
          }).finally(() => {
            that.getUserInfo()
          })
        }, 2000)
      }

      if (index == 3) {
        this.codeImgShow = true
        if (this.task_list[index - 1].status) return this.onToast('该任务已完成');
        this.logger.sum('迷途之光_预约页_任务三，关注公众号');
        setTimeout(() => {
          task(params).then((res) => {
            console.log('完成任务')

          }).finally(() => {
            that.getUserInfo()
          })
        }, 2000)
      }

    },
    getReward() {
      function throttle(func, delay) {
        let timeoutId;

        return function () {
          if (!timeoutId) {
            timeoutId = setTimeout(() => {
              func.apply(this, arguments);
              timeoutId = null;
            }, delay);
          }
        };
      }
      if (!this.isUserInfo) {
        console.log('请先登录')
        throttle(this.changeLoginPopup(true), 1000)
        return this.onToast('很抱歉，请先登录');
      }
      if (!this.activity.reward_start || !this.isRewardStart) return this.onToast('6月20日 10:00后开放领取')
      if (!this.userInfo.hasOwnProperty('role_id')) {
        console.log('选择角色')
        throttle(this.changeOsPopup(true), 1000)
        return
      } else if (!this.userInfo.role_id) {
        console.log('选择角色')
        throttle(this.changeOsPopup(true), 1000)
        return
      } else if (!this.userInfo.role_id.length) {
        console.log('选择角色')
        throttle(this.changeOsPopup(true), 1000)
        return
      }
      this.sureShow = true
    },
    reward() {
      const params = { ...this.userInfo }
      reward(params).then(res => {
        this.logger.sum('迷途之光_预约页_领取奖励');
        console.log('res------>', res)
        if (res.code === 200) {
          this.priceShow = true
          this.onToast(res.message)
          this.getUserInfo()
        } else {
          this.priceShow = false
          this.onToast(res.message)
        }
      })

    },

    scrollToElement(target) {
      const element = document.getElementById(target); // 获取目标元素
      element.scrollIntoView({
        behavior: 'smooth' // 使用平滑滚动效果（可选）
      });
    },
    // 复制链接w
    onCopy(my_id) {
      if (!this.userInfo.account) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }
      this.logger.sum('迷途之光_预约页_复制链接邀请好友');
      const clipboard = new Clipboard(my_id);
      console.log(clipboard, 'clipboard')
      clipboard.on('success', (e) => {
        console.log(clipboard, 'success')
        this.onToast('邀请链接复制成功，快快发送给你的好友吧~');
        this.showImg = 'https://download4.qcplay.com/h5-images/active/mitu/order/pop/copy_success.png',
          this.showImgShow = true
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        console.log(clipboard, 'error')
        this.onToast('复制失败');
      });
    },

    initShareData() {
      try {
        const { protocol, host } = window.location;
        if (this.activity.code) {
          this.shareLink = `${protocol}//${host}/mitu/order/enter/${getRandomString()}?invitation_code=` + this.activity.code;
          this.$set(this, 'shareLink', this.shareLink)
          this.isSetShare(this.shareLink);
          // 例如：获取好友助力信息等
        }
      } catch (err) {
        // 错误信息
        console.log('err', err);
      }
    },
    getHotNum() {
      const that = this
      // 获取热力值
      function changeCardPhoto(that, num) {
        for (var i = 0; i < num; i++) { that.card[i].photoSrc = that.card[i].photo_active }
      }
      hotNum().then(response => {
        this.hotNum = response.data.book_num;
        if (this.hotNum > 300000) {
          changeCardPhoto(that, 5)
        }
        if (this.hotNum > 200000) {
          changeCardPhoto(that, 4)
        }
        if (this.hotNum > 150000) {
          changeCardPhoto(that, 3)
        }
        if (this.hotNum > 100000) {
          changeCardPhoto(that, 2)
        }
        if (this.hotNum > 50000) {
          changeCardPhoto(that, 1)
        }
      })
    },
    // 获取用户信息
    async getUserInfo() {
      const that = this
      const params = {
        invitation_code: '',
        company: 'qc'
      }
      await onGetInitDataAPI(params).then(response => {
        that.preloadingShow = false;
        if (response.code === 200) {
          that.activity = response.data.activity
          localStorage.setItem("open_link", response.data.activity.url_scheme);

          if (this.$route.query.invitation_code && that.inviteSgin) {
            that.invite()
            that.inviteSgin = false
          }

          this.rewardSum = that.activity.task_list.reduce((accumulator, currentValue) => accumulator + currentValue.is_get_reward, 0)
          that.isUserInfo = true

          that.initShareData();
          that.onInitState(response);

          that.task_list = response.data.activity.task_list
          that.user_info = response.data.userinfo;
          that.onInitState(response);
          // 例如：获取好友助力信息等
        } else {
          that.isUserInfo = false
          that.onToast(response.message);
          that.setInitUserInfo();
          that.setInitActiveInfo();
        }
      }).catch(() => {
        that.preloadingShow = false;
      }).finally(() => {
        document.onvisibilitychange = null
      })
    },
    onInitState(response) {
      const { code } = response || {}
      if (response.code == 200) {
        console.log('初始化数据成功');
        this.setUserInfo(response.data.userinfo);
      }
      // 很抱歉，请先登录！
      if (response.code == 403) {
        this.changeLoginPopup(true);
      }
    },
    // 清除data里面相关数据
    clearActiveInfo() {
      this.isUserInfo = false; // 是否获取到用户信息，用于判断是否显示登录弹窗等
      this.isLogin = false; // 是否登录，用于判断是否显示登录弹窗等
      this.isSelectRole = false; // 是否选择角色，用于判断是否显示选择角色弹窗等
      this.isSelectServer = false; // 是否选择服务器，用于判断是否显示选择服务器弹窗等
      this.helpSign = false
      this.inviteSgin = true

      this.task_list = [
        {
          "id": 1,
          "name": "\u524d\u5f80TapTap\u9884\u7ea6\u5e76\u8bc4\u4ef7\u6e38\u620f",
          "status": false,
          "package_id": 1,
          "num": 1,
          "is_get_reward": false
        },
        {
          "id": 2,
          "name": "\u6dfb\u52a0\u4f01\u4e1a\u5fae\u4fe1",
          "status": false,
          "package_id": 2,
          "num": 1,
          "is_get_reward": false
        },
        {
          "id": 3,
          "name": "\u5173\u6ce8\u300a\u8ff7\u9014\u4e4b\u5149\u300b\u516c\u4f17\u53f7",
          "status": false,
          "package_id": 3,
          "num": 1,
          "is_get_reward": false
        },
        {
          "id": 4,
          "name": "\u9080\u8bf7\u597d\u53cb",
          "status": false,
          "package_id": 4,
          "num": 2,
          "is_get_reward": false
        }
      ]
      this.activity = {
        "invitation": [
        ],
        "task_list": [
          {
            "id": 1,
            "name": "\u524d\u5f80TapTap\u9884\u7ea6\u5e76\u8bc4\u4ef7\u6e38\u620f",
            "status": false,
            "package_id": 1,
            "num": 1,
            "is_get_reward": false
          },
          {
            "id": 2,
            "name": "\u6dfb\u52a0\u4f01\u4e1a\u5fae\u4fe1",
            "status": false,
            "package_id": 2,
            "num": 1,
            "is_get_reward": false
          },
          {
            "id": 3,
            "name": "\u5173\u6ce8\u300a\u8ff7\u9014\u4e4b\u5149\u300b\u516c\u4f17\u53f7",
            "status": false,
            "package_id": 3,
            "num": 1,
            "is_get_reward": false
          },
          {
            "id": 4,
            "name": "\u9080\u8bf7\u597d\u53cb",
            "status": false,
            "package_id": 4,
            "num": 2,
            "is_get_reward": false
          }
        ],
        "code": "feHrfhzH",
        "reward_start": false,
        "url_scheme": "weixin:\/\/dl\/business\/?t=o4RzaIEHSMa"
      },
        this.$set(this, 'task_list', this.task_list)
      this.setInitUserInfo();
      this.setInitActiveInfo();
    },
    LoginCallBack() {
    },
    // 选择角色后
    selectCallback() {
      // 初始化
      this.sureShow = true
    },
    getSelectInfo(selectInfo) {
      this.selectInfo = selectInfo
      selectInfo.account = this.userInfo.account
      this.setUserInfo(selectInfo);
    },
    loginSuccess() {
      this.getUserInfo()
    },
    reInit() {
      console.log('清除data里面相关数据')
      this.clearActiveInfo(); // 清除data里面相关数据
    },
    onOfficial() {
      this.isWechatBrowser = wechatBrowser();
      if (this.isWechatBrowser) { // 在微信app下
        console.log('在微信app下');
        return this.wxLoadShow = true
      }
      this.logger.sum('迷途之光_预约页_，前往下载');
    },
    // 区组弹窗注销-相关参数复位
    osCancell() { },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // TAG: 其他简易封装的方法
    openPopup(name) {
      if (!this.isUserInfo) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }
      this[name] = true;
    },
    closePopup(name) {
      this[name] = false;
    },
    // 微信分享
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/mitu/oreder/enter${getRandomString()}`,
        title: '迷途之光6月20日正式上线！！',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/lhyuC5SuMedasTVE6M7oQYnHF4VR5NyyQ23z6jNn.png',
        desc: '就差你了！超爽肉鸽像素弹幕射击戏《迷 途之光》6月20日上线，点击下方链接加入小队 预约游戏领海量奖励！'
      })
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/mitu/order/index/index.vue